import React from 'react'

export default function PaddingExpander({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'
    return (
        <svg
            className={className}
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path d='M17 6L17 14' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
            <path d='M3 6L3 14' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
            <path d='M6 3L14 3' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
            <path d='M6 17L14 17' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
        </svg>
    )
}
